import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { HashLink } from "react-router-hash-link";
import { Menu } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Social } from "./Social";
import { Contacts } from "./Contacts";
import {
  getCategories,
  getIsProductsLoading,
  getLang,
  getProducts,
} from "../redux/selectors";
import { switchLang } from "../redux/user/slice";
import { filterCart } from "../redux/cart/slice";
import { reorganizeData } from "../data/helpers";

export const MenuCategories = ({ anchorEl, open, handleClose }) => {
  const lang = useSelector(getLang);
  const productsData = useSelector(getProducts);
  const categoriesData = useSelector(getCategories);
  const sortedCategories = [...categoriesData].sort(
    (a, b) => a.order - b.order
  );
  const isLoading = useSelector(getIsProductsLoading);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isFR = pathname.startsWith("/fundraising");

  useEffect(() => {
    dispatch(filterCart(isFR ? ["fr"] : ["md", "lg"]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFR]);

  const productsNew = productsData.length
    ? reorganizeData(productsData, sortedCategories)
    : [];

  const productsFiltered = productsNew.filter(
    (category) =>
      category.products.length > 0 &&
      category.products.reduce((acc, prod) => acc + Number(prod.show), 0) > 0
  );

  const availableCategory = productsFiltered
    .filter((category) =>
      category.products.some((prod) =>
        prod.variants.some(
          (variant) => variant.packageSize === (isFR ? "fr" : "md" || "lg")
        )
      )
    )
    .map(({ categoryId, categoryName }) => {
      return { categoryId, categoryName };
    });

  const weddingCateringPDF =
    "https://res.cloudinary.com/dchlwbjak/image/upload/v1762191114/Catering_wedding_menu_jwjxrc.pdf";

  const cateringPDF =
    "https://res.cloudinary.com/dvloxectq/image/upload/v1762086144/Multicook/pdf/multicook_lunch_menu_zmx1gk.pdf";

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <li onClick={handleClose} className="px-4 pt-3 pb-2">
        <NavLink
          to={isFR ? "/" : "/fundraising"}
          className="block text-center text-lg font-bold uppercase bg-[#93D1DA] text-mainBlack py-2 rounded-md hover:brightness-110 transition-all"
        >
          {isFR
            ? lang === "en"
              ? "Main Menu"
              : "Основне меню"
            : lang === "en"
            ? "Fundraising"
            : "Фандрейзинг"}
        </NavLink>
      </li>

      <li onClick={handleClose} className="px-4 pb-2">
        <a
          href={cateringPDF}
          target="_blank"
          rel="noopener noreferrer"
          className="block text-center text-lg font-bold uppercase bg-[#BAD648] text-mainBlack py-2 rounded-md hover:brightness-110 transition-all"
        >
          {lang === "en" ? "Catering Menu (PDF)" : "Кейтеринг меню (PDF)"}
        </a>
      </li>

      <li onClick={handleClose} className="px-4 pb-2">
        <a
          href={weddingCateringPDF}
          target="_blank"
          rel="noopener noreferrer"
          className="block text-center text-lg font-bold uppercase bg-[#BAD648] text-mainBlack py-2 rounded-md hover:brightness-110 transition-all"
        >
          {lang === "en"
            ? "Wedding Catering (PDF)"
            : "Весільний кейтеринг (PDF)"}
        </a>
      </li>

      <hr className="my-2 border-gray-300" />

      {/* Category links */}
      {isLoading ? (
        <div className="p-4 text-center text-gray-500">Loading ...</div>
      ) : (
        availableCategory.map((el) => (
          <li
            className="py-1 px-6 text-xl hover:bg-bluredBlack cursor-pointer"
            key={el.categoryId}
            onClick={handleClose}
          >
            <HashLink to={`#menu_${el.categoryId}`} smooth>
              <span className="font-lato w-full">{el.categoryName[lang]}</span>
            </HashLink>
          </li>
        ))
      )}
      <li className="flex md:hidden items-center justify-between py-1 px-6 bg-bluredBlack text-2xl">
        <Social position="menu" />
        <div className="flex gap-5 text-3xl">
          <Icon
            icon={"twemoji:flag-canada"}
            className={
              lang !== "en"
                ? "grayscale-[100%] brightness-75"
                : "brightness-100"
            }
            onClick={() => {
              dispatch(switchLang("en"));
            }}
          />
          <Icon
            icon={"twemoji:flag-ukraine"}
            className={
              lang !== "ua"
                ? "grayscale-[100%] brightness-75"
                : "brightness-100"
            }
            onClick={() => {
              dispatch(switchLang("ua"));
            }}
          />
        </div>
      </li>

      <li className="py-0">
        <Contacts position="menu" />
      </li>
    </Menu>
  );
};
